var $ = require("jquery");
var $win = $(window);

window.zokyoThrottleAnimation = true;

function Pager() {
    document.addEventListener("DOMContentLoaded", this._init.bind(this));
}

Pager.prototype._init = function () {

    this.$el = $('[data-scroll-into-view]');
    this.itemMap = [];


    this._setup();
    this._handleResize();
    $win.on("scroll", this._handleScroll.bind(this));
    $win.on("resize", this._handleResize.bind(this));

    $win.trigger('scroll');

};

Pager.prototype._handleResize = function (e) {
    var _this = this;
    this.winHeight = $win.innerHeight();

    this.$el.each(function (i,e) {
        var $el = $(e);
        var calcTop = Math.floor($el.offset().top) + ( _this.winHeight / 10 );

        _this.itemMap[i] = {
            el: e,
            top: calcTop
        };
    });
};

Pager.prototype._handleScroll = function (e) {
    if (!this.handlingIt) {
        this.handlingIt = true;
        window.requestAnimationFrame(this._runScroll.bind(this));
    }
};

Pager.prototype._runScroll = function (e) {
    var _this = this;

    var scrollPos = window.pageYOffset;
    var scrollBottom = Math.floor(scrollPos + _this.winHeight);


    $.each(_this.itemMap, function (i, val) {
        var el = $(val.el);
        var cssClass = 'is-in-view';
        var delay = el.attr('data-scroll-into-view')

        if (scrollBottom > val.top) {
            el.addClass(cssClass);
            if ( delay === 'delay' ) {

                // console.log('window.zokyoThrottleAnimation');

                if ( window.zokyoThrottleAnimation ) {
                    setInterval(function () {
                        var svg = el.find('svg').clone();
                        el.find('svg').remove();
                        el.prepend(svg);
                    }, 3600);
                    window.zokyoThrottleAnimation = false;
                }
            }
        }
        // else {
        //     $(val.el).removeClass('is-in-view');
        // }
    });

    // end
    this.handlingIt = false;
};


Pager.prototype._setup = function(){
    this.$el.addClass('is-setup');
};


module.exports = new Pager();


// WEBPACK FOOTER //
// ./source/assets/scripts/scroll-in-view.js